import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { GET_INVESTOR_IMAGE } from "./apiRoutes";
import { API_BASE_URL } from "../consts";

interface UseGetAnnualReportingImageByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getInvestorInfoImageById = async (id: string) =>
  await axiosAuth.get(`${API_BASE_URL}${GET_INVESTOR_IMAGE}/${id}`, {
    responseType: "blob",
  });

const useGetInvestorInfoImageById = ({
  id,
  queryParams,
}: UseGetAnnualReportingImageByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["investor-info-image", id],
    queryFn: () => getInvestorInfoImageById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetInvestorInfoImageById;
